import { X, Zap } from "lucide-react";

export default function UpgradeModal({ onDismiss, reason }) {
  const isLimitReached = reason === "limit";

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4 bg-black/70 backdrop-blur-sm">
      <div className="relative w-full max-w-md bg-[#141414] border border-[#2A2A2A] rounded-2xl p-8 shadow-2xl">
        <button
          onClick={onDismiss}
          className="absolute top-4 right-4 text-gray-600 hover:text-gray-400 transition-colors"
        >
          <X size={20} />
        </button>

        <div className="flex items-center justify-center w-12 h-12 bg-[#FF0000]/10 rounded-xl mb-6">
          <Zap size={24} className="text-[#FF0000]" />
        </div>

        <h2 className="text-2xl font-black text-white mb-2">
          {isLimitReached
            ? "You've used your 3 free sifts."
            : "You've been creating for 7 days."}
        </h2>

        <p className="text-gray-400 mb-6 leading-relaxed">
          {isLimitReached
            ? "You've already turned 3 videos into publish-ready content. Upgrade to keep going — no limits, no caps."
            : "You've been using YouSift for a week. If it's working, let's make it official. Upgrade for unlimited access."}
        </p>

        <div className="bg-[#1A1A1A] border border-[#2A2A2A] rounded-xl p-4 mb-6">
          <p className="text-xs text-gray-500 uppercase tracking-widest mb-3">What you get</p>
          <ul className="space-y-2">
            {[
              "Unlimited video sifts",
              "LinkedIn posts + blog articles",
              "Priority processing",
              "Early access to new formats",
            ].map((item) => (
              <li key={item} className="flex items-center gap-2 text-gray-300 text-sm">
                <span className="w-1.5 h-1.5 rounded-full bg-[#FF0000] shrink-0" />
                {item}
              </li>
            ))}
          </ul>
        </div>

        <a
          href="mailto:hello@bethanylabs.com?subject=YouSift Upgrade"
          className="block w-full py-4 bg-[#FF0000] hover:bg-[#CC0000] text-white font-black text-center rounded-xl transition-all duration-200 mb-3"
        >
          Upgrade Now
        </a>

        <button
          onClick={onDismiss}
          className="block w-full py-3 text-gray-500 hover:text-gray-300 text-sm text-center transition-colors"
        >
          Maybe later
        </button>
      </div>
    </div>
  );
}
